import store from '../config/configureStore';

export const getRestService = (serviceName) => {
  const state = store.store.getState();
  const client = state.rest.rest;
  return client.service(serviceName);
};
